export const COOKIE_PREFERENCES_COOKIE = 'OptanonConsent';
export const ANALYTICAL_EXPERIENCE_COOKIES_GROUP = 'C0007';
export const FUNCTIONAL_COOKIES_GROUP = 'C0003';
export const PERFORMANCE_COOKIES_GROUP = 'C0002';
export const TARGETING_ADVERTISING_COOKIES_GROUP = 'C0004';
export const TECHNICAL_COOKIES_GROUP = 'T0001';
export const CONSENT_TRUE_FLAG = '1';
export const DATA_DOMAIN_SCRIPT = '52a28b58-7a56-4776-a0ae-7a3cda34da20';
export const DATA_DOMAIN_SCRIPT_TESTING = `${DATA_DOMAIN_SCRIPT}-test`;

export const COOKIE_MODAL_SCRIPT_PRELOAD_URL =
  'https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js';

export const COOKIE_MODAL_SCRIPT_PRECONNECT_HREF = 'https://cdn-ukwest.onetrust.com';
